// ── profile ────────────────────────────────────────────────────────────────
/**
 * Position (FR-PRO-03): a badge on every user icon and the map pin. Checked in code. Top to bottom is
 * the Fucking spectrum a member picks from; Side is never picked, it's what the badge shows for someone
 * who sucks and doesn't fuck (`shownPosition`).
 */
export const POSITION_OPTIONS = {
    top: { label: 'Top', icon: 'arrow-up' },
    vers_top: { label: 'Vers top', icon: 'arrows-up-lean' },
    vers: { label: 'Vers', icon: 'arrows-up-down' },
    vers_bottom: { label: 'Vers bottom', icon: 'arrows-down-lean' },
    bottom: { label: 'Bottom', icon: 'arrow-down' },
    side: { label: 'Side', icon: 'arrows-side', hint: 'Into everything but anal' },
};
/** The positions a member picks under Fucking, in the editor's one-row spectrum. */
export const FUCKING_POSITIONS = ['top', 'vers_top', 'vers', 'vers_bottom', 'bottom'];
/**
 * Sucking (FR-PRO-02), Receive to Give, each with its arrow: left receives, right gives, both ways
 * both. A Side's badge shows the arrow (`positionBadge`). Checked in code.
 */
export const SUCKING_OPTIONS = {
    receive: { label: 'Receive only', icon: 'arrow-left' },
    both: { label: 'Give & receive', icon: 'arrows-side' },
    give: { label: 'Give only', icon: 'arrow-right' },
};
/** Each badge's drawing (an ICONS name) and its words. */
export const POSITION_BADGES = {
    ...Object.fromEntries(Object.entries(POSITION_OPTIONS).map(([k, o]) => [k, { icon: o.icon, label: o.label }])),
    ...Object.fromEntries(Object.entries(SUCKING_OPTIONS).map(([k, o]) => [
        `side_${k}`,
        { icon: o.icon, label: `Side · ${o.label}` },
    ])),
};
/** The badge for a shown position: a Side who said which way they suck shows that arrow (bugs.md). */
export function positionBadge(position, sucking) {
    if (!position || !(position in POSITION_OPTIONS))
        return null;
    if (position === 'side' && sucking && sucking in SUCKING_OPTIONS)
        return `side_${sucking}`;
    return position;
}
export const BODY_TYPE_OPTIONS = {
    slim: { label: 'Slim' },
    average: { label: 'Average' },
    athletic: { label: 'Athletic' },
    muscular: { label: 'Muscular' },
    stocky: { label: 'Stocky' },
    large: { label: 'Large' },
};
/**
 * Meeting (FR-PRO-02), which replaced Can host (migration 0040: "can host" became Prefer to host,
 * "can't host" Travel only). The Can host and Can travel filters go by `MEETING_GROUP`.
 */
export const MEETING_OPTIONS = {
    host_only: { label: 'Host only' },
    prefer_host: { label: 'Prefer to host' },
    prefer_travel: { label: 'Prefer to travel' },
    meet_out: { label: 'Meet out', hint: 'Somewhere else: a spot, a car, a hotel' },
    travel_only: { label: 'Travel only' },
};
/** The Plus filter on meeting (FR-MAP-06): Can host or Can travel. */
export const MEET_FILTER_OPTIONS = {
    host: { label: 'Can host' },
    travel: { label: 'Can travel' },
};
/** Which filter each meeting choice counts for: the first three host, the other two travel. */
export const MEETING_GROUP = {
    host_only: 'host',
    prefer_host: 'host',
    prefer_travel: 'host',
    meet_out: 'travel',
    travel_only: 'travel',
};
/**
 * The position a person's badge shows, and the one others see and filter on: their Fucking choice
 * while Fucking is on, else Side when they set Sucking, else none. A Position saved with Fucking off
 * stays the owner's own, hidden. Before Fucking existed (`fucking` unset), a saved position meant yes.
 */
export function shownPosition(stats) {
    if (stats.fucking == null && stats.position === 'side')
        return 'side';
    const fucks = stats.fucking ?? !!stats.position;
    if (fucks)
        return stats.position && stats.position !== 'side' ? stats.position : null;
    return stats.sucking ? 'side' : null;
}
//# sourceMappingURL=profile.js.map